module.exports = __webpack_public_path__ + "static/media/objects_06.b5484653.svg";